document.addEventListener('DOMContentLoaded', function () {
    // Zmienne przechowujące elementy
    const bgForSidePanels = document.querySelector('.bg-for-side-panels');
    const superMenu = document.querySelector('.menu-super');
    const jobPanels = document.querySelectorAll('.job-panels__panel');

    // Funkcja zamykająca menu po kliknięciu na tło
    function closeMenuOnBgClick() {
        if (superMenu) {
            superMenu.classList.remove('menu-super--active');
        }
        if (bgForSidePanels) {
            bgForSidePanels.classList.remove('bg-for-side-panels--active');
        }
        if (jobPanels) {
            jobPanels.forEach(panel => {
                panel.classList.remove('job-panels__panel--active');
            })
        }
    }

    // Przypisanie zdarzenia kliknięcia do tła
    if (bgForSidePanels) {
        bgForSidePanels.addEventListener('click', closeMenuOnBgClick);
    }
});
